import {
  FAMILYCONTACT_LOADING,
  GET_FAMILYCONTACT,
  GET_FAMILYCONTACT_SUCCESS,
  GET_FAMILYCONTACT_FAIL,
  ADD_FAMILYCONTACT_SUCCESS,
  ADD_FAMILYCONTACT_FAIL,
  DELETE_FAMILYCONTACT_SUCCESS,
  DELETE_FAMILYCONTACT_FAIL,
  UPDATE_FAMILYCONTACT_SUCCESS,
  UPDATE_FAMILYCONTACT_FAIL,
  FAMILYCONTACT_RESET
} from "./actionType";

const INIT_STATE = {
  familyContacts: [],
  error: {},
};

const FamilyContact = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FAMILYCONTACT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_FAMILYCONTACT:
          return {
            ...state,
            familyContacts: action.payload.data,
            isFamilyContactCreated: false,
            isFamilyContactSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_FAMILYCONTACT_FAIL:
      switch (action.payload.actionType) {
        case GET_FAMILYCONTACT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isFamilyContactCreated: false,
            isFamilyContactSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_FAMILYCONTACT: {
      return {
        ...state,
        isFamilyContactCreated: false,
        loading: true,
      };
    }

    case FAMILYCONTACT_LOADING: {
      return {
        ...state,
        isFamilyContactCreated: false,
        loading: true,
      };
    }

    case ADD_FAMILYCONTACT_SUCCESS:
      return {
        ...state,
        isFamilyContactCreated: true,
        loading: false,
        familyContacts: [action.payload.data, ...state.familyContacts],
      };

    case ADD_FAMILYCONTACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_FAMILYCONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        familyContacts: state.familyContacts.filter(
          familyContact => familyContact.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_FAMILYCONTACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_FAMILYCONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        familyContacts: state.familyContacts.map(familyContact =>
          familyContact.id.toString() === action.payload.data.id.toString() ? { ...familyContact, ...action.payload.data } : familyContact
        ),
      };

    case UPDATE_FAMILYCONTACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FAMILYCONTACT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default FamilyContact;